import React, { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import { Col, Heading, Row } from 'idsk-react-components';
import './vyhlasovanieVZbierke.scss';

interface Props {
  text: string | null | undefined
}

const VyhlasovanieVZbierke = (
  { text }
  : Props,
): ReactElement => (
  <div className="vyhlasovanie">
    <Heading size="xl">Vyhlasovanie v Zbierke zákonov SR</Heading>
    {text && (
      <Row className="vyhlasovanie-main__row">
        <Col className="vyhlasovanie-main__col" width="two-thirds">
          <>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
          </>
        </Col>
      </Row>
    )}
  </div>

);

export default VyhlasovanieVZbierke;
